export function addInputHiddenForTags(labelName, labelValue) {
  const allForms = document.querySelectorAll('.wg-form')

  allForms.forEach((form) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = labelName
    input.value = labelValue
    input.classList.add('wg-input')
    form.appendChild(input)
  })
}
